<template>

  <SortableGrid 
      :heroes="heroes"
      :columns="columns"
      :filterKey="filterKey"
  />
</template>

<script>
import SortableGrid from '@/components/SortableGrid.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'PlayerGrid',
  mixins: [getTeamsMixin],
  components: {
    SortableGrid
  },
  data() {
    return {
        'filterKey': '',
        'columns': ['name', 'target', 'hr', 'points', 'projectedPoints', 'percentOfTarget', 'plateAppearances', 'games', 'numberSelected']
    };
  },
  computed: {
    heroes() {
      return this.$store.state.teamData.teamData.players ? this.$store.state.teamData.teamData.players: []
    },
  },
  created() {
    // Ensure data is loaded when this view is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>